import { isMobile as MobileView, isDesktop as DesktopView, isTablet as TabletView } from "react-device-detect";
import { useSelector } from "react-redux";

export const isMobile = () => {
	const { isClient } = useSelector(state => state.global);

	return isClient && MobileView;
};

export const isDesktop = () => {
	const { isClient } = useSelector(state => state.global);

	return isClient && DesktopView;
};

export const isTablet = () => {
	const { isClient } = useSelector(state => state.global);

	return isClient && TabletView;
};
